import { NextSeo } from 'next-seo';
import React from 'react';

import { Container, Typography } from '@seuk/design-system/atoms';

import { Main as MainContainer } from '../../components';
import { FormPageTitle, FormSection } from '../../components/forms/forms';

const ContactThankYou = () => {
  return (
    <MainContainer>
      <NextSeo title="How can we help your business?" noindex={true} nofollow={true} />
      <FormSection>
        <Container>
          <FormPageTitle>How can we help your business?</FormPageTitle>
          <Typography variant="lead">
            Thank you for contacting us regarding your query. We’ll contact you in the next 2 working days. When we
            contact you, it would be useful if you had your invoice to hand.
          </Typography>
        </Container>
      </FormSection>
    </MainContainer>
  );
};

export default ContactThankYou;
